export default __webpack_public_path__ + "static/media/task-skipped.abf2349a.svg";